import { shouldRenderOhsForm } from './proInstrument';
import { WpLeadWidget } from '../contexts/lead';
import { WpSlideWidget } from '../contexts/pitch';
import {
  type OxfordAnswers,
  isOxfordQuestionAnswered,
  canAdvanceFromOxfordQuestion,
  areAllOxfordQuestionsAnswered,
  buildOxfordLeadValues,
  buildOxfordApiValues,
  parseOxfordAnswers,
  areCampaignOxfordWidgetsComplete,
  transformOxfordWidgetValuesForSubmit,
} from './oxfordSubmit';

export type OhsAnswers = OxfordAnswers;

export const isOhsQuestionAnswered = isOxfordQuestionAnswered;
export const canAdvanceFromOhsQuestion = canAdvanceFromOxfordQuestion;
export const areAllOhsQuestionsAnswered = areAllOxfordQuestionsAnswered;
export const buildOhsLeadValues = buildOxfordLeadValues;
export const buildOhsApiValues = buildOxfordApiValues;
export const parseOhsAnswers = parseOxfordAnswers;

export function areCampaignOhsWidgetsComplete(
  widgets: WpSlideWidget[],
  leadWidgets: WpLeadWidget[],
): boolean {
  return areCampaignOxfordWidgetsComplete(widgets, leadWidgets, shouldRenderOhsForm);
}

export function transformOhsWidgetValuesForSubmit(
  leadWidgets: WpLeadWidget[],
  campaignWidgets: WpSlideWidget[],
): WpLeadWidget[] {
  return transformOxfordWidgetValuesForSubmit(leadWidgets, campaignWidgets, shouldRenderOhsForm);
}
